import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { SalesPage } from './pages/SalesPage';
import { AuroraBackground } from './components/AuroraBackground';
export function App() {
  return <LanguageProvider data-id="element-0">
      <AuroraBackground data-id="element-1" />
      <SalesPage data-id="element-2" />
    </LanguageProvider>;
}